import * as request from '../api-request'

export const getAiModels = async () => {
  return request.toJSON('GET', 'common/ai/models', {})
}
